<style scoped lang="less">
	.monthsgactive {
		background-color: rgba(255, 255, 255, .2);
		border: 1px solid red;
	}

	/deep/ .el-empty {
		width: 100%;

		.el-empty__description p {
			color: #fff !important;
			font-size: 1vw;
		}
	}

	.nowyear {
		background-color: #427ac3;
		color: #fff;
	}


	/deep/ #sxpople {
		margin-top: -46px;
	}


	@media (min-width: 100px) and (max-width: 845px) {
		.grid-content2 {
			justify-content: space-evenly !important;
		}
	}

	@media (min-width: 100px) and (max-width: 980px) {
		/deep/ .titles {
			display: none;
		}

	}

	@media (min-width: 100px) and (max-width: 768px) {
		.monthst {
			margin: 1rem 0;
		}

		// .monthsb{
		// 	margin-top: 1rem;
		// }
		.el-col {
			margin-top: 1rem;
		}
	}

	@media (min-width: 100px) and (max-width: 450px) {
		.el-row:last-child {
			height: 46rem;
		}


		.grid-content3 {
			margin-top: 1rem;
		}

		.sxpromise {
			margin-top: 2rem;
		}

		.userlist {
			margin-top: 4rem !important;
		}

	}

	@media (min-width: 451px) and (max-width: 960px) {
		.el-row:last-child {
			height: 46rem;
		}


		.grid-content3 {
			margin-top: 1rem;
		}

		.sxpromise {
			margin-top: 2rem;
		}

		.userlist {
			margin-top: 2rem;
		}


		.sxpromise {
			margin: 2rem 0;
		}


	}


	/deep/ .el-row {
		margin-bottom: 1rem;
		height: 25rem;

		.el-col {
			height: 100%;
		}

		.grid-content2 {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			height: 100%;
			position: relative;

			.montebtn {
				position: absolute;
				top: 3%;
				left: 3%;

				span {
					padding: 0.2rem 1rem;
					border: 1px solid;
					color: #fff;
					border-radius: 10px;
					margin-right: 10px;
				}
			}

		}
	}


	.grid-content.gtspx {
		// height: 10rem;
		padding: 0.2rem 0;
		border: 1px solid transparent;
		border-radius: 5px;
		overflow: hidden;
		background: #0AB94A;
		// box-shadow: 2px 2px 6px 1px;
		height: 100%;

		.gridccbottom {
			margin: 0.4rem;
			color: #fff;
			border-top: 1px solid #fff;

			.gridcchilice {
				margin: 0.4rem 0;
				font-size: 1rem;

			}

			.ridio {
				margin-left: 1rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;

				.el-radio {
					margin: 0.4rem 1rem;
				}


				/deep/ .el-radio__label {
					color: #fff;
				}

				/deep/ .el-radio__input.is-checked .el-radio__inner {
					border-color: #fff;
					background: #fff;
				}

				/deep/ .el-radio__inner::after {
					width: 8px;
					height: 8px;
					background-color: #0AB94A;
				}


			}
		}

		.sbmassage {
			color: #fff;
			margin: 0.6rem;
			font-size: 0.8rem;

			div {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 5px;

				p {
					margin-right: 10px;
				}
			}
		}

		.gtsptitle {
			margin: 0 0 0.2rem 10px;
			color: #fff;
			font-size: 1rem;
		}

		.gridcenter {
			width: 100%;
			// height: 10rem;
			position: relative;

			span {
				position: absolute;
				right: 10px;
				bottom: 10px;
				border: 1px solid;
				color: #fff;
				padding: 0.1rem 0.6rem;
				border-radius: 10px;
			}

			span:hover {
				background: #fff;
				color: #333;
				border-color: #fff;
			}

			img {
				width: 100%;
				height: 200px;
			}
		}
	}

	.monthst,
	.monthsb {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding: 1rem;
		height: 100%;
		border-radius: 10px;
		color: #fff;
		flex-direction: column;
		justify-content: flex-start;
		align-content: center;
		background-color: #00BFBF;

		.echtashp {
			width: 100%;
			height: 15rem;

			/deep/ div.sectorag {
				height: 100%;
			}

			/deep/ #sxpice {
				height: 100%;
			}
		}

		.title {
			text-align: center;
			height: 2rem;
			width: 100%;
			margin: 0 auto;
			margin-top: 1.8rem;

			p {
				font-size: 1.2rem;

			}
		}
	}

	.monthsb {
		background-color: #100C2A;
		align-items: center;
	}


	.nowsbdata {
		height: 20rem;
		border-radius: 10px;
		// border: 1px solid #5470C6;
	}

	.sxpromise {
		border: 1px solid #FFA319;
		border-radius: 10px;
		background-color: #fff;

		.sxpromiset {
			padding: 0 10px 20px;
			margin: 10px 0;
		}

		.sxpromisetitle {
			padding: 0.4rem 0;
			display: flex;
			align-items: center;
			background: #FFA319;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			color: #fff;

			p {
				font-size: 1rem;
				font-weight: 700;

				span {
					font-size: 0.8rem;
					font-weight: 400;
				}
			}

			.incons {
				border: 1px solid;
				font-size: 1.4rem;
				border-radius: 10px;
				background-color: rgba(255, 255, 255, .2);
				margin: 0 10px;
				color: #fff;
				padding: 0.2rem;
				box-sizing: border-box;

			}
		}
	}

	.userlist {
		background: #fff;
		padding-bottom: 1rem;

		.usernamet {
			display: flex;
			align-items: center;
			position: relative;

			.shenghe {
				// position: absolute;
				// top: 6%;
				display: block;
				text-align: center;
				width: 5vw;
				border: 1px solid;
				margin-left: 0.4rem;
				color: #fff !important;
				background-color: #EC8000;
				border-radius: 10px;

			}

		}

		.classlisttitlelew {

			.classlisttitle {
				border-top-left-radius: 10px;
				border-top-right-radius: 10px;
			}

			.statisititl {
				display: flex;
				align-items: center;
				padding: 0.4rem 0;
				color: #fff;

				span.incons {
					border: 1px solid;
					font-size: 1.4rem;
					border-radius: 10px;
					background-color: rgba(255, 255, 255, .2);
					margin: 0 10px;
					color: #fff;
					padding: 0.2rem;
					box-sizing: border-box;
				}

				p {
					font-size: 1.4rem;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;

					span {
						padding: 0;
						font-size: 0.8rem !important;
						box-sizing: border-box;
					}
				}
			}
		}

		.wxscllo {
			width: 100%;
			padding: 0 2.5%;
			text-align: center;
			margin-top: 1rem;
			overflow: scroll;
			overflow-x: hidden;
			height: 26rem;
			border-top: 1px solid #e7e7e7;

			&::-webkit-scrollbar {
				display: none;
			}

			.list {
				margin-top: 1rem;
			}

			.list-item {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0.4rem 0 0.4rem 0;
				border-bottom: 1px solid #f4f4f4;

				button {
					width: 4vw;
					padding: 0.2rem 0;
					border: 1px solid;
					border-radius: 40px;
					color: #fff;
					background-color: #8400FF;
					font-size: 0.4vw;

					span {
						margin-left: 4px;
					}
				}

				.username {
					// margin-right: 7rem;
					text-align: left;
					margin-left: 0.4rem;

					p {
						margin-bottom: 2px;
						color: #333;
						font-weight: 800;
						font-size: 0.8rem;

					}

					span {
						color: #57CA22;
					}
				}
			}


		}

		.inouts {
			width: 95%;
			margin: 1rem auto;
			padding: 0 0 0 0;
			box-sizing: border-box;

			/deep/ .el-input__prefix {
				top: 22%;
				left: 3% !important;
				font-size: 1rem;
			}

			/deep/ .el-input__inner {
				border-radius: 2rem;

			}

			span {
				position: relative;
				top: 29px;
				font-size: 1.2rem;
				color: #333;
				left: 9px;
			}

			input {
				padding: 0.4rem 2rem;
				width: 100%;
				font-size: 1rem;
				border-radius: 40px;
				// box-shadow: 2px 0 10px 4px #e2e2e2;
				box-sizing: border-box;
				border: 1px solid transparent;
			}
		}
	}
</style>
<template>
	<div>
		<titles :titlename="trainsobj.te_deviceName + '- 使用情况分析'" titlecontent="这里可以看到设备使用情况分析" :mbx="paths"></titles>

		<el-dialog :show-close="false" title="审核用户预约设备" :visible.sync="centerDialogVisible" width="50%" center>

			<el-descriptions border :column="2">
				<el-descriptions-item label="真实姓名">
					{{tabledeobj1.ui_realName}}
				</el-descriptions-item>
				<el-descriptions-item label="头像">
					<el-popover placement="top-start" title="" trigger="hover">
						<img v-if="tabledeobj1.ui_photoPath==null" src="../../images/header.jpg" alt=""
							style="width: 150px;height: 150px;border-radius: 50%;">
						<img v-if="tabledeobj1.ui_photoPath != null" :src="tabledeobj1.ui_photoPath" alt=""
							style="width: 150px;height: 150px;border-radius: 50%;">
						<img v-if="tabledeobj1.ui_photoPath==null" slot="reference" src="../../images/header.jpg"
							style="width: 40px;height: 40px;border-radius: 50%;">
						<img v-if="tabledeobj1.ui_photoPath != null" slot="reference" :src="tabledeobj1.ui_photoPath"
							style="width: 40px;height: 40px;border-radius: 50%;">
					</el-popover>
				</el-descriptions-item>
				<el-descriptions-item label="所属班级">
					{{tabledeobj.user.cla_name}}
				</el-descriptions-item>
				<el-descriptions-item label="所属专业">
					{{tabledeobj.user.pro_name}}
				</el-descriptions-item>
				<el-descriptions-item label="实训设备">
					{{tabledeobj.appoint.te_deviceName}}
				</el-descriptions-item>
			</el-descriptions>


			<el-form :model="form">
				<el-form-item label="请选择是否通过">
					<el-radio-group v-model="form.resource">
						<el-radio label="通过" ></el-radio>
						<el-radio label="驳回" ></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="通过或者驳回说明">
					<el-input type="textarea" v-model="form.desc" placeholder="当前值可以选填,可以为空"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="oktable()">确 定</el-button>
			</span>
		</el-dialog>



		<el-row :gutter="20">
			<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
				<div class="grid-content gtspx">
					<p class="gtsptitle">
						<span class="el-icon-s-unfold"></span>
						{{trainsobj.te_deviceName}}
					</p>
					<div class="gridcenter">
						<img v-if="trainsobj.te_image!=''" :src="trainsobj.te_image" alt="">
						<img v-else src="../../images/gtsxtu.jpg" alt="">
						<span @click="gotrainssb()">详情....</span>
					</div>
					<div class="sbmassage">
						<p>
							设备编号：<span>{{trainsobj.te_deviceNumber}}</span>
						</p>
						<div>
							<p>
								所属实训室：<span>{{trainsobj.sx_tr_name}}</span>
							</p>
							<p>
								设备责任人：<span>{{trainsobj.te_maintenancer}}</span>
							</p>
						</div>
					</div>
					<div class="gridccbottom">
						<p class="gridcchilice">
							更改设备状态 <span class="el-icon-edit-outline">
							</span>
						</p>
						<div class="ridio">
							<el-radio @change="chanasgb" v-model="radio" label="1">
								正常（启用）
							</el-radio>
							<el-radio @change="chanasgb" v-model="radio" label="2">
								离线
							</el-radio>
							<el-radio @change="chanasgb" v-model="radio" label="3">
								维护/检修
							</el-radio>
							<el-radio @change="chanasgb" v-model="radio" label="4">
								空闲
							</el-radio>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
				<div class="grid-content2">
					<div class="montebtn">
						<span @click="changesb()" :class="{monthsgactive:monthsg==1}">设备使用率</span>
						<span @click="monthsg=2" :class="{monthsgactive:monthsg==2}">预约统计</span>
					</div>
					<div class="monthst" v-show="monthsg==1">
						<div class="title">
							<p>{{yearl}}年{{monthk}}月</p>
							<span>当前设备使用率</span>
						</div>
						<el-empty :image-size="100" v-if="optionsb1.length==0" description="本月暂无使用记录"></el-empty>
						<div v-show="optionsb1.length!=0" class="echtashp">
							<userchats :datetype="'pie'"></userchats>
						</div>
					</div>

					<div class="monthsb" v-show="monthsg==2">
						<div class="title">
							<p>本周预约统计</p>
							<span>当前设备</span>
						</div>
						<div class="echtashp">
							<userchats :datetype="'pie1'"></userchats>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="8" :lg="10" :xl="10">
				<div class="grid-content3" style="border: 1px solid #5470C6;border-radius: 0.8rem; height: 100%;background: #fff;">
					<div style="position: relative; width: 100%;padding: 0.4rem 0;font-size: 1rem;text-align: center;">
						<p>{{yearl}}年当前设备实训数据</p>
						<div style="position: absolute;right: 1%;top: 5%;">
							<el-dropdown @command="commayear">
								<span class="el-dropdown-link">
									<i style="font-size: 1.2rem;" class="el-icon-s-operation el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item :class="{'nowyear':item.dictValue == yearl}"
										v-for="(item,index) in nfOptions" :key="index" :command="item.dictLabel">
										{{item.dictValue}}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
					<div class="nowsbdata" style="height: 100%;">
						<userchats :datetype="'linear'"></userchats>
					</div>
				</div>
			</el-col>

		</el-row>

		<el-row :gutter="20">
			<el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
				<div class="grid-content sxpromise">
					<div class="sxpromisetitle">
						<span class="el-icon-s-platform incons"></span>
						<p>
							实训预约
							<span>
								预约审核与预约数据查看
							</span>
						</p>
					</div>
					<div class="sxpromiset">
						<fullcalendars :oknumlist="oknumlists" :powerlist="powerlists"></fullcalendars>
					</div>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
				<div class="grid-content">
					<div class="userlist" style="border: 1px solid #5569FF;border-radius: 12px;">
						<div class="classlisttitlelew">
							<div class="classlisttitle" style="background-color: #5569FF;margin-bottom: 0;">
								<div class="statisititl">
									<span class="el-icon-help incons" style="font-size: 1.4rem;"></span>
									<p style="font-size: 1rem;">
										实训预约成员列表
										<span>
											{{timerclass}}
										</span>
									</p>
								</div>
							</div>
						</div>


						<div class="infinite-list-wrapper" style="overflow:auto">
							<div class="inouts">
								<el-input placeholder="搜索学员" @change="changeclass()" v-model="classnames">
									<i style="cursor: pointer;" slot="prefix" class="el-icon-search"
										@click="changeclass()"></i>

								</el-input>
								<!-- <span class="el-icon-search"></span>
								<input type="text" > -->
							</div>
							<div class="wxscllo">
								<ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
									<li v-for="(item,index) in classlist" :key="index" class="list-item">
										<div
											style="display: flex;align-items: center;width: 100%;justify-content: space-between;">
											<div class="usernamet">
												<img style="width: 40px;height: 40px; border-radius: 50%;"
													v-if="item.ui_photoPath == null" src="../../images/header.jpg"
													alt="">
												<img style="width: 40px;height: 40px;border-radius: 50%;"
													v-if="item.ui_photoPath" :src="item.ui_photoPath" alt="">
												<div class="username">
													<div style="display: flex;align-items: center;">
														<p>{{item.ui_realName}}</p>
														<span v-if="item.ap_auditState=='待审核'"
															class="shenghe">{{item.ap_auditState}}</span>
														<span v-if="item.ap_auditState=='已取消'" class="shenghe"
															style="background-color:#8f8f8f;">{{item.ap_auditState}}</span>
														<span v-if="item.ap_auditState=='审核通过'" class="shenghe"
															style="background-color:#45bf19;">{{item.ap_auditState}}</span>
														<span v-if="item.ap_auditState=='已完成'" class="shenghe"
															style="background-color:#45bf19;">{{item.ap_auditState}}</span>
														<span v-if="item.ap_auditState=='已驳回'" class="shenghe"
															style="background-color:#ff007f; ">{{item.ap_auditState}}</span>
													</div>
													<div>
														<span>学号：<i>{{item.ui_joyNumber}}</i></span>

													</div>
												</div>
											</div>
											<div class="promiseuser">
												<p>预约时间段</p>
												<span>{{item.ap_startTime}} ~ {{item.ap_endTime}}</span>
											</div>
											<button v-if="item.ap_auditState=='待审核'" @click="doudnet(item)">审核<span
													class="el-icon-s-help"></span></button>
										</div>

									</li>
								</ul>

								<p v-if="loading">加载中...</p>
								<p v-if="noMore">没有更多了</p>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import userchats from "@/components/chats/userchats.vue"
	import fullcalendars from "@/components/FullCalendar/fullcalendars.vue"
	import {
		GetWeekEquipmentUsage,
		GetsyEquipmentUsage,
		GetsbEquipmentTrainSTA,
		// 设备日历
		GetsbTrainEquipmentAppoint,
		GetsbTrainAppointList,
		AppointmentOnAudit
	} from "@/request/api/dataorder/dataprder.js"

	import {
		getUpdatetrainsb,
		GetscTrainingSetSingle
	} from "@/request/api/trainroom/trainroom.js"
	import {
		getAppointmentSingle
	} from "@/request/api/userapi/studenthome.js"
	import AppOptions from '@/config/AppOptions.vue';



	export default {
		data() {
			return {
				// 弹窗
				centerDialogVisible: false,
				tabledeobj1: {

				},
				tabledeobj: {
					user: {},
					appoint: {}
				},
				form: {
					resource:"通过"
				},
				timerclass: "",
				oknumlists: [0, 1, 2, 3, 4, 5],
				// 单选
				radio: "1",
				// 标题
				paths: [{
					path: "/allmanage/statistics",
					name: "数据分析与统计"
				},{
					path: "/information/devicetatistics",
					name: "设备使用情况分析"
				}],
				// 实训预约成员列表
				count: 1,
				loading: false,
				classlist: [],
				// 图表
				optionsb1: [{
					value: "",
					name: "使用中"
				}, {
					value: "",
					name: "空闲"
				}],
				optionsb2: [{
						value: 400,
						name: '周一',
					},
					{
						value: 600,
						name: '周二'
					},
					{
						value: 580,
						name: '周三'
					},
					{
						value: 500,
						name: '周四'
					},
					{
						value: 600,
						name: '周五'
					},
					{
						value: 500,
						name: '周六'
					},
					{
						value: 400,
						name: '周日'
					},
				],
				optionsb3: {
					linesdata: [100, 120, 110, 130, 120, 110, 120, 110, 130, 120, 110, 110],
					ciregcl: [60, 10, 50, 55, 60, 70, 60, 71, 81, 50, 40, 60]
				},

				// 中部图表
				monthsg: 1,
				chart1: "",
				chart2: "",
				chart3: "",
				// 设备列表
				trainsobj: JSON.parse(localStorage.getItem("trainbin")),
				// 获取当前本周一
				mouthsl: "",
				monthk: "",
				yearl: "",
				// 年份列表
				nfOptions: [],
				// 年份列表
				powerlists: [],
				// 班级名字查找
				classnames: "",
				// 日期开始到结束
				datebegin: "",
				endtimer: ""
			}
		},
		created() {
				AppOptions.appEmpty = false;
			},
		computed: {
			noMore() {
				return this.count >= 10
			},
			disabled() {
				return this.loading || this.noMore
			}
		},
		watch: {
			monthsg(newv, oldv) {
				// console.log(oldv)
				if (newv == 1) {
					this.$nextTick(() => {
						this.chart1.resize()
					})
				} else {
					this.$nextTick(() => {
						this.chart2.resize()
					})
				}
			}
		},
		beforeMount() {
			let date = new Date()
			// "日期开始"
			let datebegin = new Date(date.setDate(1)).toLocaleString().slice(0, 10)
			let endtimer = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleString().slice(0, 10)
			this.datebegin = datebegin
			this.endtimer = endtimer
			// this.trainsobj = JSON.parse(this.$cookie.get("trainbin"))
			// console.log(this.trainsobj.sx_te_guid,"当前实训设备")
			
			
			GetscTrainingSetSingle(this.trainsobj.sx_te_guid).then(res => {
				// console.log("可预约，回显", res)
				if (res.data.data) {
					this.oknumlists = res.data.data.sx_ts_trainCycle.split(",")
				}
			})


			this.radio = this.trainsobj.te_deviceState == 1 ? "1" : this.trainsobj.te_deviceState == 0 ? "2" 
			: this.trainsobj.te_deviceState == -1 ? "3" : "4"
			// console.log(this.radio,"单选回显")
			this.getdatemonth()
			this.getnowmonth()
			this.getsbsta()
			this.getEquipmentAppoint()
		},
		mounted() {
			// this.trainsobj = JSON.parse(this.$cookie.get("trainbin"))
			this.getNf()
			this.getclassstadentlist()
			this.getEquipmentUsage()
		},
		methods: {
			gotrainssb(){
				// console.log(this.trainsobj)
				this.$router.push("/device/roomxq?id=2&name=实训设备&sx_te_guid="+ this.trainsobj.sx_te_guid)
				
			},
			doudnet(item) {
				// console.log(item)
				this.tabledeobj1 = item
				this.centerDialogVisible = true
				getAppointmentSingle(item.sx_ap_guid).then(res => {
					// console.log(res, "获取用户信息")
					this.tabledeobj.appoint = res.data.data.appoint
					this.tabledeobj.user = res.data.data.user
				})
			},
			oktable() {
				// this.centerDialogVisible = false
				let shbleobj = {
					sx_ap_guid: this.tabledeobj1.sx_ap_guid,
					isagree: this.form.resource == "通过" ? true : false,
					ap_auditGuid: localStorage.getItem("uiguid"),
					ap_auditContent: this.form.desc ?? ""
				}
				// console.log(shbleobj)
				AppointmentOnAudit(shbleobj).then(res => {
					// console.log(res)
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.centerDialogVisible = false
						this.desc = ""
						this.$nextTick(()=>{
							this.getclassstadentlist()
						})
						
						// location.reload()
					} else {
						this.$message(res.data.msg);
					}

				})
			},

			// 查找成员列表
			changeclass() {
				// 查询成员列表
				// console.log("查询成员列表")
				this.getclassstadentlist(this.timerclass == "" ? this.getNowFormatDate() : this.timerclass)
			},

			// 获取学生设备列表
			getclassstadentlist(data = null) {
				let classobj = {
					sx_te_guid: this.trainsobj.sx_te_guid,
					ap_appDate: data == null ? this.getNowFormatDate() : data,
					ui_realName: this.classnames
				}
				this.timerclass = this.getNowFormatDate()
				if (data) {
					this.timerclass = data
				}

				GetsbTrainAppointList(classobj).then(res => {
					// console.log(res, "班级数据")
					let calsslist = []
					if (res.data.data && res.data.data.length > 0) {
						this.classlist = res.data.data
					} else {
						this.classlist = calsslist
					}
				})
			},



			// 获取设备使用日期
			getEquipmentAppoint() {
				let TrainEquiobj = {
					sx_te_guid: this.trainsobj.sx_te_guid,
					startTime: this.datebegin,
					endTime: this.endtimer
				}
				GetsbTrainEquipmentAppoint(TrainEquiobj).then(res => {
					// console.log(res, "设备使用日期")
					this.powerlists = res.data.data
				})
			},

			// 更改设备状态
			chanasgb() {
				// console.log(this.radio)
				let radiostabe = this.radio == 1 ? 1 : this.radio == 2 ? 0 : this.radio == 3 ? -1 : -2
				// console.log(radiostabe)
				let tasbobj = {
					sx_te_guid: this.trainsobj.sx_te_guid,
					te_deviceNumber: this.trainsobj.te_deviceNumber,
					te_deviceName: this.trainsobj.te_deviceName,
					te_maintenancer: this.trainsobj.te_maintenancer,
					te_deviceMac: this.trainsobj.te_deviceMac,
					te_tag: this.trainsobj.te_tag,
					te_deviceIp: this.trainsobj.te_deviceIp,
					te_deviceIntroduction: this.trainsobj.te_deviceIntroduction,
					sx_tr_guid: this.trainsobj.sx_tr_guid,
					te_deviceRemark: this.trainsobj.te_deviceRemark,
					te_deviceState: radiostabe,
					file: this.trainsobj.te_image
				}
				let from_data = new FormData()
				from_data.append("sx_te_guid", tasbobj.sx_te_guid)
				from_data.append("te_deviceNumber", tasbobj.te_deviceNumber)
				from_data.append("te_deviceName", tasbobj.te_deviceName)
				from_data.append("te_maintenancer", tasbobj.te_maintenancer)
				from_data.append("te_deviceMac", tasbobj.te_deviceMac)
				from_data.append("te_tag", tasbobj.te_tag)
				from_data.append("te_deviceIp", tasbobj.te_deviceIp)
				from_data.append("te_deviceIntroduction", tasbobj.te_deviceIntroduction)
				from_data.append("sx_tr_guid", tasbobj.sx_tr_guid)
				from_data.append("te_deviceRemark", tasbobj.te_deviceRemark)
				from_data.append("te_deviceState", tasbobj.te_deviceState)
				from_data.append("file", tasbobj.file)

				getUpdatetrainsb(from_data).then(res => {
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.trainsobj.te_deviceState = radiostabe
						// this.$cookie.set("trainbin", JSON.parse(this.trainsobj))
							
							
						

					} else {
						this.$message(res.data.msg);
					}
				})


			},

			// 切换年份
			commayear(e) {
				this.yearl = e
				this.getsbsta()
			},
			// 获取实训数据
			getsbsta() {
				let TrainSTAobj = {
					sx_te_guid: this.trainsobj.sx_te_guid,
					year: this.yearl
				}
				GetsbEquipmentTrainSTA(TrainSTAobj).then(res => {
					// console.log(res, "获取实训数据")
					let timerenth = []
					let fcontlist = []
					res.data.data.forEach(item => {
						timerenth.push(item.timeLength)
						fcontlist.push(item.fcount)
					})
					this.optionsb3.linesdata = timerenth
					this.optionsb3.ciregcl = fcontlist
					this.chars()
				})
			},


			// 年份列表
			getNf() {
				var nfOptionsArray = new Array();
				var years = new Date().getFullYear();
				for (var i = years - 3; i <= years + 3; i++) {
					var anOption = {};
					anOption.dictValue = i;
					anOption.dictLabel = i;
					nfOptionsArray.push(anOption);
				}
				this.nfOptions = nfOptionsArray;
				// console.log(nfOptionsArray)
			},


			getEquipmentUsage() {
				let Usages = {
					sx_te_guid: this.trainsobj.sx_te_guid,
					month: this.monthk
				}
				GetsyEquipmentUsage(Usages).then(res => {
					// console.log(res.data.data, "设备使用")
					if (res.data.data) {
						// Math.floor(res.data.data .usage * 100) / 100
						let nums = res.data.data  
						this.optionsb1[0].value = nums
						this.optionsb1[1].value = 100 - nums
						this.chars()
					} else {
						this.optionsb1 = []
					}
					// console.log(this.optionsb1, "设备使用")
				})
			},

			getnowmonth() {
				let weekeqip = {
					sx_te_guid: this.trainsobj.sx_te_guid,
					time: this.mouthsl
				}
				GetWeekEquipmentUsage(weekeqip).then(res => {
					// console.log(res, "预约统计")
					res.data.data.forEach((item, index) => {
						this.optionsb2[index].value = item.count
					})
					this.chars()
				})
			},

			// 日期转换
			getMyDate(str) {
				var oDate = new Date(str),
					oYear = oDate.getFullYear(),
					oMonth = oDate.getMonth() + 1,
					oDay = oDate.getDate(),
					oHour = oDate.getHours(),
					oMin = oDate.getMinutes(),
					oSen = oDate.getSeconds(),
					oTime = oYear + '/' + oMonth + '/' + oDay
				return oTime;
			},
			// 获取日期
			getdatemonth() {
				var today = new Date();
				//构建当前日期,格式：2022-08-22 00:00:00
				var year = today.getFullYear(); //本年 
				var month = today.getMonth() + 1; //本月
				var day = today.getDate(); //本日
				var newDate = new Date(year + "-" + month + "-" + day + " 00:00:00"); //年月日拼接
				var nowTime = newDate.getTime(); //当前的时间戳
				var weekDay = newDate.getDay(); //当前星期 0.1.2.3.4.5.6 【0 = 周日】
				var oneDayTime = 24 * 60 * 60 * 1000; //一天的总ms
				var mondayTime = (1 - weekDay) * oneDayTime + nowTime; //本周一的时间戳
				this.mouthsl = this.getMyDate(mondayTime)
				// console.log(this.mouthsl)
				this.monthk = this.mouthsl.split("/")[1]
				this.yearl = this.mouthsl.split("/")[0]
				// console.log(this.monthk)

			},
			//获取当前日期函数
			getNowFormatDate() {
				let date = new Date(),
					seperator1 = '/', //格式分隔符
					year = date.getFullYear(), //获取完整的年份(4位)
					month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
					strDate = date.getDate() // 获取当前日(1-31)
				if (month >= 1 && month <= 9) month = '0' + month // 如果月份是个位数，在前面补0
				if (strDate >= 0 && strDate <= 9) strDate = '0' + strDate // 如果日是个位数，在前面补0

				let currentdate = year + seperator1 + month + seperator1 + strDate
				return currentdate
			},

			// 改变图图表
			changesb() {
				this.monthsg = 1
				this.chart1.resize()
				this.getEquipmentUsage()

			},
			load() {
				this.loading = true
				setTimeout(() => {
					this.count += 6
					this.loading = false
				}, 2000)
			},
			chars() {
				this.$store.commit("channgeoptionsb1", this.optionsb1)
				this.$store.commit("changeoptionsb2", this.optionsb2)
				this.$store.commit("changeoptionsb3", this.optionsb3)
				var chart1 = this.$echarts.init(document.getElementById("sxpice"))
				this.chart1 = chart1
				chart1.setOption(this.$store.state.optionsb1);
				var chart2 = this.$echarts.init(document.getElementById("sxpople"))
				chart2.setOption(this.$store.state.optionsb2);
				this.chart2 = chart2
				var chart3 = this.$echarts.init(document.getElementById("sector"))
				chart3.setOption(this.$store.state.optionsb3);
				this.chart3 = chart3
				chart1.resize()
				chart2.resize()
				chart3.resize()

				window.onresize = () => {
					return (() => {
						chart1.resize()
						chart2.resize()
						chart3.resize()
						// this.screenWidth = window.screenWidth
					})()
				}
			}
		},
		components: {
			titles,
			userchats,
			fullcalendars
		}

	}
</script>
